// Shared angle helpers, one copy of each wrap and clamp used across src/.
// Leaf module, no imports, so anything - including a Node type-stripped tool
// - can pull it in.

/** Wrap degrees to -180..180, closed on both ends (wrap180(180) === 180). */
export function wrap180(deg: number): number {
  const w = deg % 360;
  if (w > 180) return w - 360;
  if (w < -180) return w + 360;
  return w;
}

/** Wrap degrees to [-180..180), half-open, mapping +180 to -180 for canonical longitude. */
export function wrap180HalfOpen(deg: number): number {
  return ((((deg + 180) % 360) + 360) % 360) - 180;
}

/**
 * Wrap radians to -PI..PI, closed on both ends (wrapRad(Math.PI) === Math.PI).
 * One turn per pass, so an infinite angle never returns.
 */
export function wrapRad(rad: number): number {
  let r = rad;
  while (r > Math.PI) r -= Math.PI * 2;
  while (r < -Math.PI) r += Math.PI * 2;
  return r;
}

/** Clamp v to [lo, hi]. */
export function clamp(v: number, lo: number, hi: number): number {
  return v < lo ? lo : v > hi ? hi : v;
}
